import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02a3c7ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-skill" }
const _hoisted_2 = { class: "add-skill__list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skill) => {
        return (_openBlock(), _createElementBlock("li", {
          key: skill.name,
          class: "add-skill__skill",
          onClick: ($event: any) => (_ctx.add(skill.name))
        }, [
          _createElementVNode("button", {
            title: _ctx.$t('ui-add') + ' ' + _ctx.$t(`skill__${skill.name}`),
            class: "add-skill__button"
          }, _toDisplayString(skill.localizedName), 9, _hoisted_4)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}